<template>
  <section
    id="new-physician-creation"
    class="case-creation"
    v-loading="loading"
  >
    <div class="container-small-table" v-loading="disableSubmitButton">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title" v-if="physician_id">Edit Physician</h3>
              <h3 class="title" v-else>Add Physician</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div class="vue-form" v-if="!loading">
              <el-form
                :model="physicianFormData"
                class="vue-form"
                disabled
              >
                <el-row :gutter="20">
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          NPI Number
                          <span class="star">*</span>
                        </label>
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <el-input
                            maxlength="10"
                            placeholder="Enter NPI Code"
                            v-model="physicianFormData.npi_code"
                            
                          ></el-input>

                          <el-button class="npi-button" @click="searchDoctor">
                            <img
                              src="@/assets/images/icons/npi-search.svg"
                              alt="icon"
                            />
                          </el-button>
                        </div>
                        <p
                          class="err error-break"
                          v-if="getErrors && getErrors.npi_code"
                        >
                          <FormError errorName="npi_code"></FormError>
                        </p>
                        <p
                          class="err error-break"
                          v-if="getErrors && getErrors.npi_number"
                        >
                          <FormError errorName="npi_number"></FormError>
                        </p>
                        <p
                          class="err error-break"
                          v-if="
                            getPhysicianSearchValidationErrors &&
                            getPhysicianSearchValidationErrors.error_code
                          "
                        >
                          {{
                            this.getPhysicianSearchValidationErrors.error_code
                          }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Physician Name
                          <span class="star">*</span>
                        </label>
                        <el-input
                          placeholder="Physician Name "
                          v-model="physicianFormData.name"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="name"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"> Physician First Name </label>
                        <el-input
                          placeholder="Physician First Name "
                          v-model="physicianFormData.first_name"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="first_name"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"> Physician Middle Name </label>
                        <el-input
                          placeholder="Physician Middle Name "
                          v-model="physicianFormData.middle_name"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="middle_name"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"> Physician Last Name </label>
                        <el-input
                          placeholder="Physician Last Name "
                          v-model="physicianFormData.last_name"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="last_name"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Phone Number
                          <span class="star">*</span>
                        </label>
                        <el-input
                          placeholder="Enter Phone Number"
                          v-model="physicianFormData.phone"
                          maxlength="10"
                          
                        ></el-input>
                        <p class="err error-break">
                          <FormError errorName="phone"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"> Email </label>
                        <el-input
                          class="email-lower"
                          type="email"
                          placeholder="Enter Email"
                          v-model="physicianFormData.email"
                        ></el-input>
                        <p class="err">
                          <FormError errorName="email"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"> Fax </label>
                        <el-input
                          placeholder="Enter Fax"
                          v-model="physicianFormData.fax"
                          maxlength="10"
                          
                        ></el-input>
                        <p class="err">
                          <FormError errorName="fax"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="8" :sm="24" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Address Line 1</label>
                        <el-input
                          placeholder="Enter Address Line 1"
                          v-model="physicianFormData.address.address_line_1"
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="address.address_line_1"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="8" :sm="24" :xs="24">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Address Line 2</label>
                        <el-input
                          placeholder="Enter Address Line 2"
                          v-model="physicianFormData.address.address_line_2"
                        ></el-input>
                        <p class="err">
                          <FormError
                            errorName="address.address_line_2"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Zip
                          <span class="star">*</span>
                        </label>
                        <el-input
                          placeholder="Enter Zip"
                          maxlength="5"
                          v-model="physicianFormData.address.zip"
                          @input="getStateCity"
                          
                        ></el-input>
                        <p class="err">
                          <FormError errorName="address.zip"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <state :stateData="physicianFormData.address"></state>
                        <p class="err">
                          <FormError errorName="address.state"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <city :cityData="physicianFormData.address"></city>
                        <p class="err">
                          <FormError errorName="address.city"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Ordering Facility
                          <span class="star">*</span>
                        </label>
                        <el-select
                          v-model="physicianFormData.hospital"
                          collapse-tags
                          filterable
                          multiple
                          placeholder="Select Ordering Facility"
                          @change="getHospitalBranches"
                        >
                          <el-option
                            v-for="hospital in hospitalsData.data"
                            :key="hospital._id"
                            :label="hospital.name"
                            :value="hospital._id"
                            :disabled="isInactiveStatus(hospital)"
                            class="inactive-dropdown"
                          >
                            <span style="float: left">{{ hospital.name }}</span>
                            <span
                              v-if="isInactiveStatus(hospital)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                            >
                              Inactive
                            </span>
                          </el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="hospitals"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">Facility Branch</label>
                        <el-select
                          v-loading="loadingBraches"
                          element-loading-spinner="el-icon-loading"
                          element-loading-background="rgba(0, 0, 0, 0.8)"
                          v-model="physicianFormData.hospital_branches"
                          multiple
                          collapse-tags
                          filterable
                          placeholder="Select Facility Branch"
                        >
                          <el-option-group
                            v-for="group in getGroupHospitalBranches"
                            :key="group.label"
                            :label="group.label"
                          >
                            <el-option
                              v-for="branch in group.branches"
                              :key="branch._id"
                              :label="branch.display_name"
                              :value="branch._id"
                            >
                            </el-option>
                          </el-option-group>
                        </el-select>
                        <p class="err">
                          <FormError errorName="hospital_branches"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text">
                          Specializations
                          <span class="star"></span>
                        </label>
                        <el-select
                          placeholder="Select Specializations"
                          :clearable="true"
                          :filterable="true"
                          :multiple="true"
                          :allow-create="true"
                          v-model="physicianFormData.specializations"
                          collapse-tags
                        >
                          <el-option
                            v-for="(
                              specialization, index
                            ) in physicianFormData.specializations"
                            :key="index"
                            :label="specialization"
                            :value="specialization"
                          ></el-option>
                        </el-select>
                        <p class="err">
                          <FormError errorName="specializations"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div class="case-creation__card mt-10">
          <div class="hospitals-settings">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-case-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Physician Settings</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0">
              <div class="radio-buttons-alignments">
                <el-form disabled>
                  <el-row>
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Auto Fax :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="physicianFormData.settings.auto_fax"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="physicianFormData.settings.auto_fax"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <el-form-item
                          class="text mb-0"
                          label="Email Notifications :"
                          :required="true"
                        >
                          <div class="d-flex">
                            <el-radio
                              v-model="
                                physicianFormData.settings.email_notifications
                              "
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="
                                physicianFormData.settings.email_notifications
                              "
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>

              <p
                class="err"
                v-if="
                  getPhysicianValidationErrors &&
                  getPhysicianValidationErrors.critical_error &&
                  getPhysicianValidationErrors.critical_error.length
                "
              >
                <FormError errorName="critical_error"></FormError>
              </p>
              <p
                class="err"
                v-if="
                  getPhysicianValidationErrorsCode &&
                  getPhysicianValidationErrorsCode.data &&
                  getPhysicianValidationErrorsCode.data.error_code ===
                    'EMAIL_ALREADY_EXISTS'
                "
              >
                <span>
                  User Is Already Exists With same Email in Other Ordering
                  Facility.</span
                >
              </p>
            </div>
          </div>
        </div>

        <div class="case-creation__actions">
          <ul class="list">
            <li>
              <el-button
                type="default"
                class="btn cancel-button"
                @click="cancel"
                >Cancel</el-button
              >
            </li>
            <li v-if="this.$route.params && this.$route.params.physician_id">
              <el-button
                type="success"
                class="btn save-button"
                @click="updatePhysicianDetails"
                disabled
                :loading="disableSubmitButton"
                >Update</el-button
              >
            </li>
            <li v-else>
              <el-button
                type="success"
                class="btn save-button"
                @click="submitPhysicianDetails"
                disabled
                :loading="disableSubmitButton"
                >Save</el-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      physicianFormData: {
        npi_code: "",
        name: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        phone: "",
        fax: "",
        email: "",
        hospital: "",
        hospital_branches: [],
        specializations: [],
        address: {
          address_line_1: "",
          address_line_2: "",
          city: "",
          state: "",
          zip: "",
        },
        settings: {
          auto_fax: false,
          email_notifications: false,
        },
      },
      disableSubmitButton: false,
      serchedPhysicianData: null,
      loadingBraches: false,
      hospitalBranches: [],
      physicianInfo: {},
      hospitalsData: {},
    };
  },
  props: {
    updateOnCancel: {
      required: false,
      default: false,
    },
    formData: {
      default: {},
    },
  },
  components: {
    state,
    city,
    FormError,
  },
  computed: {
    getGroupHospitalBranches() {
      return this.hospitalBranches
        .map((hospital) => {
          hospital.branches = this.getMultipleHospitalBranches.filter(
            (branch) => branch.hospital._id == hospital._id
          );
          return hospital;
        })
        .filter((hospital) => hospital.branches && hospital.branches.length);
    },
    ...mapGetters("physicians", [
      "getPhysicianAddStatus",
      "getPhysicianValidationErrors",
      "getAddedPhysicianData",
      "getPhysicianSearchData",
      "getSinglePhysician",
      "getPhysicianSearchValidationErrors",
      "getPhysicianValidationErrorsCode",
      "getPecosData",
    ]),
    ...mapGetters("cases", ["getStateAndCity"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("branches", ["getMultipleHospitalBranches"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    physician_id() {
      if (this.$route.params.physician_id) {
        return this.$route.params.physician_id;
      }
      return null;
    },
  },
  async created() {
    await this.loadInitData();
  },
  methods: {
    addDrPrefix(firstName) {
      if (typeof firstName === "string" && !firstName.startsWith("Dr")) {
        firstName = "Dr " + firstName;
      }
      return firstName;
    },
    stripDrPrefix(name) {
      if (typeof name === "string") {
        return name.replace(/^dr\.?\s*/i, "").trim();
      }
      return name;
    },
    async getStateCity() {
      try {
        let params = {
          zip: this.physicianFormData.address.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.physicianFormData.address.state = this.getStateAndCity.state;
          this.physicianFormData.address.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async loadInitData() {
      this.loading = true;
      this.$store.dispatch("physicians/clearValidationErrors");
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));

      if (this.$route.params && this.$route.params.physician_id) {
        await this.fetchPhysicianDetails(this.physician_id);
      } else {
        this.$store.dispatch("help/fetchAllStates");
        await this.$store.dispatch("hospitals/fetchAllHospitals", {
          get_all: true,
        });
        this.$store.commit("branches/setMultipleHospitalBranches", [], {
          root: true,
        });
      }
      this.loading = false;
    },
    async fetchPhysicianDetails(physician_id) {
      await this.$store.dispatch("physicians/fetchSinglePhysician", {
        physician_id: physician_id,
        include_hospital_accounts: true,
        include_hospital_details: true,
      });
      await this.setPhysicianData(this.getSinglePhysician);
    },
    async setPhysicianData(formData) {
      this.physicianInfo = JSON.parse(JSON.stringify(formData));
      this.physicianFormData.hospital = this.physicianInfo.hospitals.map(
        (hospitaldata) => hospitaldata._id || hospitaldata
      );
      this.physicianFormData.hospitals =
        this.physicianInfo.hospitals.map((e) => e._id) || [];
      await this.$store.dispatch("branches/fetchMultipleHospitalBranches", {
        hospitals: this.physicianFormData.hospitals,
      });
      this.physicianFormData.npi_code = this.physicianInfo.npi_code || "";
      this.physicianFormData.name = this.physicianInfo.name || "";
      this.physicianFormData.first_name = this.physicianInfo.first_name || "";
      this.physicianFormData.middle_name = this.physicianInfo.middle_name || "";
      this.physicianFormData.last_name = this.physicianInfo.last_name || "";
      this.physicianFormData.phone = this.physicianInfo.phone || "";
      this.physicianFormData.fax = this.physicianInfo.fax || "";
      this.physicianFormData.email = this.physicianInfo.email || "";

      this.physicianFormData.hospital_branches =
        this.physicianInfo.hospital_branches.map((e) => e._id) || [];
      this.physicianFormData.specializations =
        this.physicianInfo.specializations || [];
      this.physicianFormData.settings = {
        ...this.physicianFormData.settings,
        ...this.physicianInfo.settings,
      };
      if (this.physicianInfo.address) {
        this.physicianFormData.address.address_line_1 =
          this.physicianInfo.address.address_line_1 || "";
        this.physicianFormData.address.address_line_2 =
          this.physicianInfo.address.address_line_2 || "";
        this.physicianFormData.address.city =
          this.physicianInfo.address.city || "";
        this.physicianFormData.address.state =
          this.physicianInfo.address.state || "";
        this.physicianFormData.address.zip =
          this.physicianInfo.address.zip || "";
      } else {
        this.physicianFormData.address.address_line_1 = "";
        this.physicianFormData.address.address_line_2 = "";
        this.physicianFormData.address.city = "";
        this.physicianFormData.address.state = "";
        this.physicianFormData.address.zip = "";
      }

      await this.getHospitalBranchesonInit();
    },

    async getHospitalBranchesonInit() {
      this.loadingBraches = true;
      this.hospitalBranches = [];
      this.setHospitalBranchOptionsData();
      await this.$store.dispatch("branches/fetchMultipleHospitalBranches", {
        hospitals: this.physicianFormData.hospital,
      });
      this.loadingBraches = false;
    },

    async getHospitalBranches() {
      this.physicianFormData.hospital_branches = [];
      this.getHospitalBranchesonInit();
    },
    setHospitalBranchOptionsData() {
      if (
        this.physicianFormData.hospital &&
        this.physicianFormData.hospital.length
      ) {
        this.hospitalBranches = this.hospitalsData.data
          .filter(
            (hospital) =>
              this.physicianFormData.hospital.indexOf(hospital._id) != -1
          )
          .map((hospital) => {
            if (this.physicianFormData.hospital.indexOf(hospital._id) != -1) {
              return {
                _id: hospital._id,
                label: hospital.name,
                code: hospital.code,
                branches: [],
              };
            }
          });
      } else {
        this.hospitalBranches = [];
      }
    },
    async searchDoctor() {
      if (
        this.physicianFormData.npi_code &&
        this.physicianFormData.npi_code.length
      ) {
        this.clearFormData();
        this.loading = true;
        await this.$store.dispatch(
          "physicians/searchPhysicianByCode",
          this.physicianFormData.npi_code
        );
        this.loading = false;

        if (this.getPhysicianSearchData) {
          this.serchedPhysicianData = JSON.parse(
            JSON.stringify(this.getPhysicianSearchData)
          );
          if (this.serchedPhysicianData.basic) {
                    // const first_Name =
            //   this.addDrPrefix(this.serchedPhysicianData.basic.first_name) ||
            //   this.addDrPrefix(
            //     this.serchedPhysicianData.basic.authorized_official_first_name
            //   );
            const first_Name = this.stripDrPrefix(
              this.serchedPhysicianData.basic.first_name ||
              this.serchedPhysicianData.basic.authorized_official_first_name
            );
            this.physicianFormData.first_name = this.stripDrPrefix(
              this.serchedPhysicianData.basic.first_name ||
              this.serchedPhysicianData.basic.authorized_official_first_name
            );
            this.physicianFormData.last_name = this.stripDrPrefix(
              this.serchedPhysicianData.basic.last_name ||
              this.serchedPhysicianData.basic.authorized_official_last_name
            );
            this.physicianFormData.middle_name = this.stripDrPrefix(
              this.serchedPhysicianData.basic.middle_name ||
              this.serchedPhysicianData.basic.authorized_official_middle_name
            );
            this.physicianFormData.name = this.stripDrPrefix(`${first_Name} ${this.physicianFormData.last_name}`);
          } else {
            this.physicianFormData.first_name = " ";
            this.physicianFormData.last_name = " ";
            this.physicianFormData.middle_name = " ";
            this.physicianFormData.name = " ";
          }
          this.physicianFormData.phone =
            this.serchedPhysicianData.addresses[0].telephone_number;
          if (
            this.physicianFormData.phone &&
            this.physicianFormData.phone.includes("-")
          ) {
            this.physicianFormData.phone = this.physicianFormData.phone.replace(
              /-/g,
              ""
            );
          }
          this.physicianFormData.email = this.serchedPhysicianData.email || "";
          this.physicianFormData.address.address_line_1 =
            this.serchedPhysicianData.addresses[0].address_1;
          this.physicianFormData.address.address_line_2 =
            this.serchedPhysicianData.addresses[0].address_2;
          this.physicianFormData.address.city =
            this.serchedPhysicianData.addresses[0].city;
          this.physicianFormData.address.state = this.getStateNameByCode(
            this.serchedPhysicianData.addresses[0].state
          );
          this.physicianFormData.address.zip =
            this.serchedPhysicianData.addresses[0].postal_code;
          if (
            this.serchedPhysicianData &&
            this.serchedPhysicianData.basic &&
            this.serchedPhysicianData.basic.credential
          ) {
            let specialization = this.serchedPhysicianData.basic.credential;
            
            if (!this.physicianFormData.specializations.includes(specialization)) {
              this.physicianFormData.specializations.push(specialization);
            }
          }
        }
      }
    },
    onSuccessEdit() {
      if (this.updateOnCancel) {
        this.$emit("onUpdate");
      } else {
        this.$router.go(-1);
      }
    },
    cancel() {
      if (this.updateOnCancel) {
        this.$emit("onCancel");
      } else {
        this.$router.go(-1);
      }
    },
    clearFormData() {
      this.physicianFormData.name = "";
      this.physicianFormData.phone = "";
      this.physicianFormData.email = "";
      this.physicianFormData.hospitals = [];
      this.physicianFormData.hospital_branches = [];
      this.physicianFormData.specializations = [];
      this.physicianFormData.address = {
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        zip: "",
      };
      this.physicianFormData.first_name = "";
      this.physicianFormData.middle_name = "";
      this.physicianFormData.last_name = "";
    },

    preparePhysicianAddData() {
      if (this.physician_id) {
        this.physicianFormData.id = this.physician_id;
      }
      this.physicianFormData.city_or_state =
        this.physicianFormData.address.city;
      this.physicianFormData.hospitals = this.physicianFormData.hospital;
      this.physicianFormData.hospital_branches =
        this.physicianFormData.hospital_branches &&
        this.physicianFormData.hospital_branches.length
          ? this.physicianFormData.hospital_branches
          : undefined;
      if (
        this.physicianFormData.specializations &&
        this.physicianFormData.specializations.length
      ) {
        this.physicianFormData.specializations =
          this.physicianFormData.specializations.map((item) =>
            item ? item.trim() : item
          );
      }
      if (this.physicianFormData.email) {
        this.physicianFormData.email =
          this.physicianFormData.email.toLowerCase();
      }
      return this.physicianFormData;
    },
    async submitPhysicianDetails() {
      this.disableSubmitButton = true;

      const payload = this.preparePhysicianAddData();
      if (!this.physicianFormData.first_name) delete payload.first_name;
      if (!this.physicianFormData.middle_name) delete payload.middle_name;
      if (!this.physicianFormData.last_name) delete payload.last_name;

      await this.$store.dispatch(
        "physicians/checkPecosStatus",
        this.physicianFormData.npi_code
      );
      if (this.getPecosData && this.getPecosData.length > 0 && this.getPecosData[0].PARTB == 'Y') {
        payload.pecos_status = true;
        payload.pecos_number = this.getPecosData[0].NPI; // Accessing the first element of the array
      } else {
        payload.pecos_status = false;
      }
      await this.$store.dispatch("physicians/addPhysician", payload);

      if (this.getPhysicianAddStatus) {
        const newPhysicianId = this.getAddedPhysicianData.data._id;

        successNotification("Physician added successfully");

        this.cancel(newPhysicianId);
      } else if (this.getPhysicianValidationErrors) {
        this.scrollToFirstError();
      } else if (
        this.getPhysicianValidationErrors &&
        this.getPhysicianValidationErrors.critical_error
      ) {
        errorNotification(this.getPhysicianValidationErrors.critical_error);
      }
      this.disableSubmitButton = false;
    },
    async updatePhysicianDetails() {
      this.disableSubmitButton = true;

      const payload = this.preparePhysicianAddData();
      if (!this.physicianFormData.first_name) delete payload.first_name;
      if (!this.physicianFormData.middle_name) delete payload.middle_name;
      if (!this.physicianFormData.last_name) delete payload.last_name;
      await this.$store.dispatch(
        "physicians/checkPecosStatus",
        this.physicianFormData.npi_code
      );
      if (this.getPecosData && this.getPecosData.length > 0 && this.getPecosData[0].PARTB == 'Y') {
        payload.pecos_status = true;
        payload.pecos_number = this.getPecosData[0].NPI; // Accessing the first element of the array
      } else {
        payload.pecos_status = false;
      }
      await this.$store.dispatch("physicians/editPhysician", payload);

      if (this.getPhysicianAddStatus) {
        successNotification(this.getPhysicianAddStatus.message);

        this.onSuccessEdit();
      } else if (this.getPhysicianValidationErrors) {
        this.scrollToFirstError();
      } else if (
        this.getPhysicianValidationErrors &&
        this.getPhysicianValidationErrors.critical_error
      ) {
        errorNotification(this.getPhysicianValidationErrors.critical_error);
      }
      this.disableSubmitButton = false;
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("error")[0];
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
  },
};
</script>

<style lang="scss">
#new-physician-creation {
  .npi-button {
    border: none;
    padding: 3px 0 0;
    background: none;
    img {
      width: 40px;
      height: 29px;
    }
  }
  .radio-buttons-alignments {
    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }
    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #ffffff;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #0a5da6;
    }
    .case-creation__input .el-form-item {
      margin-top: 10px;
      margin-bottom: 0px !important;
    }
  }
}
</style>
